import { connect } from 'react-redux';
import { formProductContainsAssetType } from 'state/common-form/commonForm.selectors';
import { quotePriceEnhancedThunk, quoteSponsoFeeThunk } from 'state/common-form/commonForm.thunks';
import type { SponsoFee, SponsoFeeField } from 'state/quotes/sponsoFees/sponsoFees';
import type { PriceEnhancement, PriceEnhancementField, PriceEnhancementMode } from 'state/quotes/trades/trades.model';
import { getInitialPriceEnhancement, getPriceEnhancementMode } from 'state/selectors';
import { getUserPriceEnhancement, getUserSponsoFees } from 'state/selectors/common/temp';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import type { QuoteWorkspaceType } from 'state/workspaces/model';
import { optionalMap } from 'utils/optional';

export interface OwnProps {
  tabId: string;
  quoteId: string;
  workspaceType: QuoteWorkspaceType;
}

export type StateProps = {
  mode: PriceEnhancementMode;
  displaySponsoFields?: boolean;
} & PriceEnhancement &
  SponsoFee;

export type DispatchProps = {
  onFieldValueChanged: (field: PriceEnhancementField, value: PriceEnhancement[PriceEnhancementField]) => void;
  onSponsoFeeFieldValueChanged?: (field: SponsoFeeField, value: SponsoFee[SponsoFeeField]) => void;
};

export type PriceEnhancerRawProps = OwnProps & StateProps & DispatchProps;

const multiplyBy100 = optionalMap<number>(x => x * 100);

const mapStateToProps = (state: AppState, { tabId, workspaceType }: OwnProps): StateProps => {
  const mode = getPriceEnhancementMode(state, workspaceType, tabId);

  const priceEnhancement =
    getUserPriceEnhancement(state, workspaceType, tabId) ?? getInitialPriceEnhancement(state, workspaceType, tabId)!;
  const sponsoFees = getUserSponsoFees(state, workspaceType, tabId);

  return {
    issuePrice: priceEnhancement.issuePrice! * 100,
    xMargin: priceEnhancement.xMargin! * 100,
    tradingOffer: priceEnhancement.tradingOffer! * 100,
    sponso: multiplyBy100(sponsoFees?.sponso),
    sponsoUpFront: multiplyBy100(sponsoFees?.sponsoUpFront),
    topUpUpFront: multiplyBy100(sponsoFees?.topUpUpFront),
    yMarginRetrocession: multiplyBy100(sponsoFees?.yMarginRetrocession),
    displaySponsoFields: formProductContainsAssetType(state, tabId, workspaceType, 'Rate'),
    mode,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId, workspaceType }: OwnProps): DispatchProps => ({
  onFieldValueChanged(field, value) {
    dispatch(quotePriceEnhancedThunk(tabId, workspaceType, field, value));
  },
  onSponsoFeeFieldValueChanged(field, value) {
    dispatch(quoteSponsoFeeThunk(tabId, workspaceType, field, value));
  },
});

export const connectPriceEnhancerRaw = connect(mapStateToProps, mapDispatchToProps);
